<!-- Model Header -->
<div class="d-flex model-container justify-content-between bg-color overflow-hidden">
    <h3 class="text-color f-w-600 p-l-10 m-y-auto">Edit Agent</h3>
    <button mat-icon-button class="text-color" (click)="this.dialogRef.close()" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<!-- Model Body -->
<div mat-dialog-content style="width: 100%; padding: 20px;" class="model-body">
    <form [formGroup]="agentForm">


        <div>
            <div class="">
                <div class="p-32">
                    <div class="row m-t-30">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Name</mat-label>
                            <mat-form-field appearance="outline" class="disble w-100" color="primary">
                                <input class="disble" matInput type="email" formControlName="name" readonly />
                            </mat-form-field>
                        </div>

                        <!-- Email field 2 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Phone Number</mat-label>
                            <mat-form-field appearance="outline" class="disble w-100" color="primary">
                                <input class="disble" matInput type="email" formControlName="phoneNumber" readonly />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Email</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">License Number</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="licenseNumber" />
                            </mat-form-field>
                        </div>


                    </div>





                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Bank Name</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="bankName" />
                            </mat-form-field>
                        </div>

                        <!-- Email field 2 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Bank Number</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="bankNumber" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Email field 1 -->
                        <div class="col-12 col-md-6 col-lg-6 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-12 d-block">Status</mat-label>
                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="status" />
                            </mat-form-field>
                        </div>

                        <!-- Email field 2 -->
                    </div>

                    <div class="row">
                        <!-- Email field 1 upload -->
                        <div class="m-l-10 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-4 d-block">Passport Upload</mat-label>
                            <!-- <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field> -->
                            <input type="file" #fileInput_1 style="display: none;"
                                (change)="uploadFile($event, fileInput_1, 1)">
                            <div class="w-100 flex">
                                <button (click)="fileInput_1.click()" class="tab-btn bg-color c-pointer">Choose
                                    File</button>
                                <span class="m-l-10">{{ (base64String[1].fileName) ?
                                    (base64String[1].fileName | slice:0:30) : 'No File chosen' }}</span>
                            </div>

                        </div>


                        <div *ngIf="isLoading[1]" class="flex items-center">
                            <span class="visually-hidden">Loading...</span>
                        </div>

                        <div class="m-l-16 m-t-10" *ngIf="getFileType(base64String[1].fileName) !== 'application/pdf'">
                            <div *ngIf="base64String[1].base64">
                                <!-- Wrap the image with an anchor tag -->
                                <a href="{{ base64String[1].base64 }}" target="_blank">
                                    <img [src]="base64String[1].base64" alt="image" width="100"
                                        (click)="openImageInNewTab(base64String[1].base64)" />
                                </a>
                            </div>
                        </div>

                        <div (click)="openInNewTab(base64String[1].base64)" class="m-l-30">
                            <!-- <iframe *ngIf="getFileType(base64String[1].fileName) === 'application/pdf'"
                                [src]="getDocumentUrl(base64String[1].base64)" height="170px"></iframe> -->
                            <iframe *ngIf="getFileType(base64String[1].fileName) === 'application/pdf'"
                                [src]="getSafeBase64Url(base64String[1].base64)" height="auto"
                                (click)="openInNewTab(base64String[1].base64)"></iframe>
                        </div>

                    </div>

                    <div class="row m-t-20">
                        <!-- Email field 2 -->
                        <!-- Email field 2 upload -->
                        <div class="m-l-10 mb-3">
                            <mat-label class="f-s-14 f-w-600 m-b-4 d-block">Government ID</mat-label>
                            <!-- <mat-form-field appearance="outline" class="w-100" color="primary">
                                <input matInput type="email" formControlName="email" />
                            </mat-form-field> -->

                            <input type="file" #fileInput_2 style="display: none;"
                                (change)="uploadFile($event, fileInput_2, 2)">
                            <div class="flex">
                                <button (click)="fileInput_2.click()" class="tab-btn bg-color c-pointer">Choose
                                    File</button>
                                <span class="m-l-10">{{ base64String[2].fileName ?
                                    base64String[2].fileName : 'No File chosen' }}</span>
                            </div>
                        </div>


                        <div *ngIf="isLoading[2]" class="flex items-center">
                            <span class="visually-hidden">Loading...</span>
                        </div>

                        <div class="m-l-16 m-t-10" *ngIf="getFileType(base64String[2].fileName) !== 'application/pdf'">
                            <div *ngIf="base64String[2].base64">
                                <!-- Wrap the image with an anchor tag -->
                                <a href="{{ base64String[2].base64 }}" target="_blank">
                                    <img [src]="base64String[2].base64" alt="image" width="100"
                                        (click)="openImageInNewTab(base64String[2].base64)" />
                                </a>
                            </div>
                        </div>

                        <div (click)="openInNewTab(base64String[2].base64)" class="m-l-30">
                            <!-- <iframe *ngIf="getFileType(base64String[1].fileName) === 'application/pdf'"
                                [src]="getDocumentUrl(base64String[1].base64)" height="170px"></iframe> -->
                            <iframe *ngIf="getFileType(base64String[2].fileName) === 'application/pdf'"
                                [src]="getSafeBase64Url(base64String[2].base64)" height="auto"
                                (click)="openInNewTab(base64String[2].base64)"></iframe>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </form>
</div>

<!-- Model Footer -->
<div mat-dialog-actions>
    <button class="bg-color text-color" mat-button>Save</button>

    <button class="bg-color text-color" mat-button (click)="this.dialogRef.close()">Close</button>
</div>